import router from '@/router/';

/**
 *
 * Criação do objecto que define uma ou várias fees anuais para cada tipo de associado.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados.
 *
 * @param {Object}  data
 *
*/
const create = async data => {
    const { isAdd } = router.history.current.meta;
    const annualFees = [];

    if ( isAdd ) {
        const allValueKeys = Object.keys( data ).filter( key => key.includes( 'value' ) );

        allValueKeys.forEach( ( key, index ) => {
            // eslint-disable-next-line
            const [ _, typeId ] = key.split( '-' );
            // Criação do objeto das quotas
            annualFees[`fees[${index}][year]`] = data.year;
            annualFees[`fees[${index}][type]`] = parseInt( typeId, 10 );
            annualFees[`fees[${index}][admission]`] = parseFloat( data[key] );
            annualFees[`fees[${index}][subscription]`] = parseFloat( data[key] );
        });
    }

    const fees = {
        ...( Object.keys( annualFees ).length && { ...annualFees })
    };

    return fees;
};

const requiredFields = [
    { field: 'year', isRequiredOnEdit: false },
    { field: 'value-1', isRequiredOnEdit: false },
    { field: 'value-2', isRequiredOnEdit: false },
    { field: 'value-3', isRequiredOnEdit: false },
    { field: 'value-4', isRequiredOnEdit: false },
    { field: 'value-5', isRequiredOnEdit: false },
    { field: 'value-6', isRequiredOnEdit: false },
    { field: 'value-7', isRequiredOnEdit: false }
];

export {
    create,
    requiredFields
};